import { render } from "./Modals.vue?vue&type=template&id=1992fd0a"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"
script.render = render

export default script